/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
import qrcode from 'qrcode';
import { deepLink } from "./config";
export class QRCodeWriter {
    drawQRCodeToCanvas(data, canvas) {
        return new Promise((resolve, reject) => {
            qrcode.toCanvas(canvas, this.stringFrom(data), { errorCorrectionLevel: 'L' }, (error) => {
                if (error) {
                    reject(error);
                }
                resolve();
            });
        });
    }
    stringFrom(data) {
        const { domain, link, apn, isi, ibi } = deepLink;
        const query = encodeURIComponent(`?uid=${data.uid}&dappName=${data.dappName}`);
        return `https://${domain}/`
            + `?link=https://${link}/link/${query}`
            + `&apn=${apn}`
            + `&isi=${isi}`
            + `&ibi=${ibi}`;
    }
}
